export default "__VITE_ASSET___g7fot_s__"